import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import type { StuckRequestsSummary } from '../../models/diagnostics.models';

@Component({
  selector: 'app-diagnostic-stuck-requests',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './diagnostic-stuck-requests.component.html',
  styleUrls: ['./diagnostic-stuck-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticStuckRequestsComponent {
  @Input() stuckSummary!: StuckRequestsSummary;
  @Input() currentPage = 1;
  @Input() currentPageSize = 10;
  @Input() loading = false;
  @Input() showSection = false;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<Event>();
  @Output() fixVisibilityForRequest = new EventEmitter<number>();
  @Output() releaseProcessingLockForRequest = new EventEmitter<number>();
  @Output() markFileReadyForStuck = new EventEmitter<number>();
  @Output() fixAllVisibility = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();

  get totalPages(): number {
    return this.stuckSummary?.totalPages ?? 1;
  }
  get totalCount(): number {
    return this.stuckSummary?.totalCount ?? 0;
  }
  get hasPrev(): boolean {
    return this.currentPage > 1;
  }
  get hasNext(): boolean {
    return this.currentPage < this.totalPages;
  }
  get totalStuck(): number {
    if (!this.stuckSummary) return 0;
    return (
      this.stuckSummary.isVisibleOnGridCount +
      this.stuckSummary.isProcessingCount +
      this.stuckSummary.isReady2ProcessCount +
      this.stuckSummary.isReady4UluroCount
    );
  }

  getStuckFlagLabel(flag: string): string {
    switch (flag) {
      case 'IsVisibleOnGrid':
        return 'IsVisibleOnGrid = 0';
      case 'IsProcessing':
        return 'IsProcessing = 1';
      case 'IsReady2Process':
        return 'IsReady2Process = 0';
      case 'IsReady4Uluro':
        return 'IsReady4Uluro = 1';
      default:
        return flag;
    }
  }

  formatAge(minutes: number): string {
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const mins = minutes % 60;
    const parts: string[] = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (mins > 0 || parts.length === 0) parts.push(`${mins}m`);
    return parts.join(' ');
  }

  trackByStuckRequestId(_index: number, item: { requestId: number }): number {
    return item.requestId;
  }
}
